import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
} from '@angular/core';
import { IconType, StatusStyle } from '@pf/shared-common';
import { NzTagColor } from 'ng-zorro-antd/tag';

export type ChipStatus = StatusStyle | 'inactive' | 'default' | 'primary-light';

@Component({
    selector: 'pf-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChipComponent {
    @HostBinding('attr.pfStatus')
    @Input()
    pfStatus?: ChipStatus;

    @Input()
    pfColor?: NzTagColor;

    @Input()
    icon?: keyof typeof IconType;
}
